<script setup lang="ts">
import useFetch from './useFetch'

withDefaults(
  defineProps<{
    show?: boolean
  }>(),
  {
    show: false
  }
)
const { isMobile } = useDevice()

const emits = defineEmits(['cancel', 'success'])
const { $currencyFormat } = useNuxtApp()
const { addCdnToUrl } = useFormatUrlCdn()
const {
  courseDetail,
  amount,
  showVoucherList,
  showConfirmation,
  selectedVoucher,
  cancelBuyCourse,
  triggerCloseConfirmation,
  triggerback,
  checkoutCourse,
  priceDiscountVoucher
} = useFetch({ emits })
</script>

<template>
  <ClientOnly>
    <AtomsModal
      :visible="show"
      :width="556"
      centered
      :closable="false"
      :mask-closable="false"
      class="kursus-detail__buy-course"
      @cancel="cancelBuyCourse"
    >
      <div class="buy-course__title">
        <div class="title-wrapper">
          Beli Kursus
          <CloseOutlined @click="cancelBuyCourse" />
        </div>
      </div>
      <template v-if="!showVoucherList">
        <div class="buy-course__info">
          <div class="info-image">
            <nuxt-img
              :src="addCdnToUrl(courseDetail?.data?.thumbnailURL)"
              :alt="courseDetail?.data?.serial"
              loading="lazy"
              size="sm:100%"
              format="webp"
              :quality="isMobile ? '50' : '80'"
              preload
            />
          </div>
          <div class="info-title">
            {{ courseDetail?.data?.title }}
          </div>
        </div>

        <div class="buy-course__price">
          <div class="price-title">Detail Pembelian</div>
          <div class="price-info">
            <div class="info-label">Harga</div>
            <div class="info-count">
              {{ $currencyFormat(courseDetail?.data?.priceNormal) }}
            </div>
          </div>
          <div
            v-if="courseDetail?.data?.priceDiscount > 0"
            class="price-info discount"
          >
            <div class="info-label">Potongan harga</div>
            <div class="info-count">
              -
              {{
                $currencyFormat(
                  courseDetail?.data?.priceNormal -
                    courseDetail?.data?.priceDiscount
                )
              }}
            </div>
          </div>
          <div v-if="selectedVoucher" class="price-info discount">
            <div class="info-label">Potongan voucher</div>
            <div class="info-count">
              - {{ $currencyFormat(priceDiscountVoucher) }}
            </div>
          </div>
          <div class="price-info amount">
            <div class="info-label">Total</div>
            <div class="info-count">{{ $currencyFormat(amount) }}</div>
          </div>
        </div>

        <div class="buy-course__action">
          <div
            v-if="selectedVoucher"
            class="action-voucher-used"
            @click="showVoucherList = true"
          >
            <div class="voucher-used__info">
              <span><LazyAtomsIconVoucher /></span>
              Voucher digunakan
            </div>
            <LazyAtomsArrowDown
              :rotate="-90"
              class="voucher-used__arrow-right"
            />
          </div>

          <template v-else>
            <a-button block @click="showVoucherList = true">
              Pilih Voucher
            </a-button>
            <div class="action-separator"><span>or</span></div>
          </template>
          <a-button type="primary" block @click="checkoutCourse">
            <template v-if="amount === 0"> Ambil Kursus </template>
            <template v-else> Lanjut ke Pembayaran </template>
          </a-button>
        </div>
      </template>

      <LazyModulesKursusDetailMoleculesBuyCourseVoucher
        v-else
        :selected-voucher="selectedVoucher"
        @on-back="triggerback"
      />
    </AtomsModal>

    <AtomsModal
      :visible="showConfirmation"
      :width="461"
      centered
      :closable="false"
      :mask-closable="false"
      :footer="null"
      class="kursus-detail__buy-course__confirmation"
    >
      <div class="confirmation-title">Batalkan Pembelian?</div>
      <div class="confirmation-desc">
        Jika dibatalkan maka progres akan hilang, tapi voucher masih bisa
        digunakan untuk transaksi selanjutnya
      </div>
      <div class="confirmation-action">
        <a-space>
          <a-button @click="showConfirmation = false">Kembali</a-button>
          <a-button type="primary" @click="triggerCloseConfirmation">
            Ya, Batalkan
          </a-button>
        </a-space>
      </div>
    </AtomsModal>
  </ClientOnly>
</template>

<style lang="scss">
@use './styles.scss';
</style>
